import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose } from '../../../../layout/redux/layoutActions'
import { Button, Dropdown, IcoAdd, IcoBin, IcoPencil, Input, List, Modal } from '../../../../components'
import { numberAleatori } from '../../../../helpers'
import { criarGrupoProduto, removerGrupoProduto, setFormProjetoLista, setMeusProjetosLoad } from '../../redux/meusProjetosActions'
import Portal from '../../../../components/portal/portal'


export default () => {
  const dispatch = useDispatch()
  const { sistema, statusModal } = useSelector(state => state.layoutState)
  const { load, meuProjeto } = useSelector(state => state.meusProjetosState)
  const nls = require(`../../nls/${sistema.idioma}.json`)

  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

  const headerDefault = [
    {
      column: 'nomeGrupoProduto',
      text: nls?.configurar.tableNome,
      className: '',
    },
    {
      column: 'actions',
      text: '',
      className: 'actions',
    }
  ]

  const handleEditForm = (e, f) => {
    dispatch(setMeusProjetosLoad({name: 'produtosAddEdit', value: {...load.produtosAddEdit, [`edit${e.idGrupoProduto}`]: !load.produtosAddEdit?.[`edit${e.idGrupoProduto}`]}}))
  } 

  const handleAddForm = e => {
    dispatch(setMeusProjetosLoad({name: 'produtosAddEdit', value: {...load.produtosAddEdit, add: !load.produtosAddEdit?.add}}))
  } 

  const handleAddEditClose = e => {
    dispatch(setMeusProjetosLoad({name: 'produtosAddEdit', value: e}))
  } 
  
  const handleRemove = e => {
    dispatch(removerGrupoProduto({...e, idProjeto: meuProjeto.projeto.idProjeto}, nlsPopup))
  } 

  const handleCloseModal = e => {
    dispatch(modalClose()) 
  }  

  return (
    <Modal
      title={nls.configurar?.gruposProdutoTitle}
      size='medium'
      open={statusModal === 'gruposProdutoMeuProjeto' ? true : false}
      close={() => dispatch(modalClose())}
      closeText={nls.criarProjeto?.btnFechar}
      actions={<>
        <Button
          color='default'
          onClick={()=> handleCloseModal()}
        >{nls.criarProjeto?.btnFechar}</Button>
      </>}
    >
      <div className='modal-meuProjeto-grupos-add'>
        <h5>{nls.configurar?.addEmpresaDetalhes}</h5>
        
        <div className='colflex justify'>
          <div>
            <h5>{nls.configurar?.subTitleListaGrupos}</h5>
          </div>
          <div>
            <GruposProdutos 
              show={load?.produtosAddEdit?.add}
              id={'add'}
              actionOpen={
                <Button
                  color='primary circle'
                  onClick={()=> handleAddForm()}
                ><IcoAdd /></Button>
              }
            />
          </div>
        </div>
        <div className='colflex'>
          <List
            header={headerDefault}
            data={meuProjeto.gruposProdutos}
            listCustom={e=> {
              const item = e

              item.actions = <>
                {/* <GruposProdutos 
                  show={load?.produtosAddEdit?.[`edit${e.idGrupoProduto}`]}
                  info={e} 
                  id={e.idGrupoProduto}
                  actionOpen={
                    <Button
                      color='primary circle'
                      onClick={()=> handleEditForm(e)}
                    ><IcoPencil /></Button>
                  }
                /> */}
                <Button
                  color='primary circle'
                  onClick={()=> handleRemove(e)}
                ><IcoBin /></Button>
              </>

              return item
            }}
            paginate={false}
            actionPaginate={(e)=> null}
            handlePerPage={(e)=> null}
            nls={nls.paginacao}
          />
        </div>
      </div>
    </Modal>
  )
}



export const GruposProdutos = ({show = false, actionOpen, info={}, id=numberAleatori()}) => {
  const dispatch = useDispatch()
  const { sistema } = useSelector(state => state.layoutState)
  const { load, meuProjeto } = useSelector(state => state.meusProjetosState)
  const nls = require(`../../nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

  const [erro, setErro] = useState({})  
  const [form, setForm] = useState({nomeGrupoProduto: ''})
  const [selectCoordinates, setSelectCoordinates] = useState({});

  useEffect(()=> {
    setForm({...form, ...info})
  }, [])
  
  useEffect(()=> {
    if (show) {
      const elem = document.getElementById(`grupo-produto-${id}`)
      openSelect(elem)
    }
  }, [form.id, show])
  
  const handleChange = e => {
    if (!e.value && form.id) {
      const list = meuProjeto.gruposProdutos.find(g=> Number(g.id) === Number(form.id))
      e.value = list.nome
    }
    setForm({...form, [e.name]: e.value})
  } 

  const handleAdd = e => {
    if (e.nomeGrupoProduto) {
      setForm({nomeGrupoProduto: ''})
      dispatch(criarGrupoProduto({...e, projetoId: meuProjeto.projeto.idProjeto, nlsPopup}))
      dispatch([
        // setFormProjetoLista({name: 'gruposProdutos', value: [...meuProjeto.gruposProdutos, {...e, id: numberAleatori()}]}),
        setMeusProjetosLoad({name: 'produtosAddEdit', value: {...load.produtosAddEdit, add: false}})
      ])
    }
  } 

  const handleEdit = e => {
    if (e.nome) {
      const list = meuProjeto.gruposProdutos.map(g=> Number(g.id) === Number(e.id) ? {...g, ...e} : g)
      setForm({nome: ''})
      dispatch([
        setFormProjetoLista({name: 'gruposProdutos', value: list}),
        setMeusProjetosLoad({name: 'produtosAddEdit', value: {...load.produtosAddEdit, [`edit${e.id}`]: false}})
      ])
    }
  } 
  
  const openSelect = (elem) => {
    if (elem) {
      let div = elem;
      let rect = div.getBoundingClientRect(),
        eixoX = rect.left,
        eixoY = rect.top,
        width = rect.width,
        height = rect.height;

      // let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;

      let coor = {};
      if (Math.ceil(eixoY + height) + 300 >= windowHeight) {
        coor = { left: eixoX - (300 - width), bottom: windowHeight - eixoY, top: 'auto' };
      } else {
        coor = { left: eixoX - (300 - width), top: eixoY + height + 1 };
      }
      setSelectCoordinates({ ...coor, position: 'absolute', minWidth: width, width: 'auto', display: 'block' });
    } else {
      setSelectCoordinates({})
    }
  };

  const handleClose = e => {
    dispatch(setMeusProjetosLoad({name: 'produtosAddEdit', value: {...load.produtosAddEdit, [form.id?`edit${form.id}`:'add']: false}}))
  }

  return <div id={`grupo-produto-${id}`} className='action-grupo'>
    {actionOpen}
    <Portal name={'box-addedit-grupo'}>
      {show? (
        <div className={`box-addedit-grupo ${id}`} style={selectCoordinates}>
          <div className='modal-meuProjeto-grupos-add-form'>
            <div>
              <Input
                name='nomeGrupoProduto'
                label={''}
                value={form?.nomeGrupoProduto}
                placeholder={nls.configurar?.formNomeGrupoPH}
                action={(e) => handleChange(e)}
                required={{
                  erro,
                  message: ''
                }}
              />
            </div>
            <div>
              <Button
                color='default'
                onClick={()=> handleClose(form)}
              >{nls?.configurar.btnCancelar}</Button>
              <Button
                color='primary'
                onClick={()=> form.id?handleEdit(form): handleAdd(form)}
              >{form.id?nls?.configurar.btnEditar:nls?.configurar.btnAdicionar}</Button>
            </div>
          </div>
        </div>
      ):null}
    </Portal>
  </div>
}